import { TeamAvatar } from '@statsbomb/kitbag-global-football';
import { useAtomValue } from 'jotai';
import { Trans, useTranslation } from 'react-i18next';
import { secureBucketCookieRequestedAtom } from '@/atoms/cookies';
import { useUrlLocale } from '@/hooks/useUrlLocale';
import { QuickStartCard } from './QuickStartCard';

export const DefaultTeamCard = ({ defaultTeam }: { defaultTeam: { team_id: number; name: string } | undefined }) => {
  const { t } = useTranslation('home');
  const locale = useUrlLocale();
  const secureBucketCookieRequested = useAtomValue(secureBucketCookieRequestedAtom);

  // Setting a default team in the New Experience comes in a later phase, and Home must not link to
  // Classic, so this state only explains why there is no shortcut.
  if (!defaultTeam) return <QuickStartCard description={t('quickStart.noDefaultTeam')} />;

  return (
    <QuickStartCard
      avatar={<TeamAvatar teamId={secureBucketCookieRequested ? defaultTeam.team_id : undefined} size="small" />}
      title={defaultTeam.name}
      description={<Trans t={t} i18nKey="quickStart.defaultTeam" components={{ bold: <strong /> }} />}
      to={`/${locale}/team/${defaultTeam.team_id}/dashboard`}
    />
  );
};
